import styled from 'styled-components';

import NormalImg from '../../components/Img';

const Img = styled(NormalImg)`
  pointer-events: none;
`;

export default Img;
